import {h, Component} from 'preact';
import {createPortal} from 'preact/compat';
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import designService from '../service/designService';

export default @connect(reduce, actions)
class NewTemplateModal extends Component {
  constructor() {
    super();

    this.markAsTemplate = () => {
      designService.markAsTemplate(this.props.designId).then(() => {
        this.props.setIsTemplate(true);
        this.props.onModalClose();
      })
    }
  }

  render(props, state) {
    return props.open ? createPortal(<div>
      <div className="modal-back" onClick={props.onModalClose}></div>
      <div className="modal">
        <header>
          <h2>Is this a template?</h2>
        </header>
        <div className="content">
          <p>
            You are starting a new design as a Designer.
            Should we mark this design as a <b>template</b>?
          </p>
          <footer>
            <a className="btn decline" onClick={props.onModalClose}>Nope</a>
            <a className="btn primary accept" onClick={this.markAsTemplate.bind(this)}>Mark as template</a>
          </footer>
        </div>
      </div>
    </div>, document.getElementById('modals')) : null;
  }
}
